// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".article-reactions-module__container--3O8_U{border-bottom:1px solid #e2e2e2;padding-bottom:30px;margin-bottom:25px}@media screen and (min-width:1152px){.article-reactions-module__container--3O8_U{padding-bottom:35px;margin-bottom:35px}}.article-reactions-module__title--27CQ8{margin-bottom:15px}.article-reactions-module__listContainer--1piWC{position:relative}@media screen and (min-width:1152px){.article-reactions-module__listContainer--1piWC{width:-moz-fit-content;width:fit-content}}", ""]);
// Exports
exports.locals = {
	"container": "article-reactions-module__container--3O8_U",
	"title": "article-reactions-module__title--27CQ8",
	"listContainer": "article-reactions-module__listContainer--1piWC"
};
module.exports = exports;
